<div class="d-flex flex-column h-100">
  <div>
    <label class="label-preview-title">{{item.templateOptions.label}} @if (item.templateOptions.required) {
      <span>*</span>
    }</label>
  </div>
  <div class="d-flex flex-column justify-content-center" style="height:100%">
    <input type="text" class="form-control" [formControl]="inputControl" inputSelectOnFocus>
    @if (inputControl.invalid && inputControl.errors['required'] && inputControl.touched) {
      <p class="validation-text text-start pb-0">{{ 'MAIN.CONTENT.WORKFLOW.REQUIRED' | translate }}</p>
    }
  </div>
</div>